import { useEffect } from "react";
import { Link, Navigate, useParams, useOutletContext } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, ArrowLeft, Check, ShieldCheck, Sparkles, LockKeyhole } from "lucide-react";
import { Reveal, EASE } from "./shared";

const pageIcons = { "on-premise-ai": ShieldCheck, "custom-ai": Sparkles, "secure-infrastructure": LockKeyhole };
const pageAccents = { "on-premise-ai": "#19d7ff", "custom-ai": "#b061ff", "secure-infrastructure": "#4d9fff" };

export function ServicePage() {
  const { slug } = useParams();
  const { t, rtl, lang, openContact } = useOutletContext();
  const page = t.servicePages[slug];
  const Icon = pageIcons[slug] || ShieldCheck;
  const Arrow = rtl ? ArrowLeft : ArrowRight;
  useEffect(() => {
    if (page) document.title = `${page.title} — VIRA`;
  }, [page, lang]);
  if (!page) return <Navigate to="/" replace />;
  return (
    <main>
      <section className="service-page-hero section-pad" data-testid="service-page">
        <div className="service-page-grid">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: EASE }}>
            <Link to="/" className="service-back" data-testid="service-back-link">{rtl ? <ArrowRight size={14} /> : <ArrowLeft size={14} />} {page.back}</Link>
            <span className="eyebrow">{page.eyebrow}</span>
            <h1 data-testid="service-page-title">{page.title}</h1>
            <div className="service-tagline" data-testid="service-page-tagline">{page.tagline}</div>
            <p>{page.p1}</p>
            <p>{page.p2}</p>
          </motion.div>
          <motion.div className="service-visual" style={{ "--accent": pageAccents[slug] }} initial={{ opacity: 0, scale: 0.94 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.9, delay: 0.15, ease: EASE }}>
            <div className="grid-lines" />
            <div className="service-visual-icon"><Icon size={64} strokeWidth={1.3} /></div>
            <span className="visual-label label-a">{page.eyebrow.split("—")[0].trim().toUpperCase()}</span>
            <span className="visual-label label-b">VIRA</span>
          </motion.div>
        </div>
        <Reveal delay={0.1}>
          <div className="service-features">{page.features.map((feature, i) => (
            <div className="service-feature" key={feature} data-testid={`service-feature-${i + 1}`}><Check size={17} /><span>{feature}</span></div>
          ))}</div>
        </Reveal>
        <Reveal delay={0.15}><div className="service-cta-block"><button className="primary-button" onClick={openContact} data-testid="service-page-cta">{page.cta} <Arrow size={16} /></button></div></Reveal>
      </section>
    </main>
  );
}
